import MenstrualCultureHero from '../components/screens/menstrual-culture/MenstrualCultureHero'
import MenstrualCultureDefinition from '../components/screens/menstrual-culture/MenstrualCultureDefinition'
import MenstrualCultureEncumePoster from '../components/screens/menstrual-culture/MenstrualCultureEncumePoster'
import MenstrualCultureGallery from '../components/screens/menstrual-culture/MenstrualCultureGallery'
import Testimonies from '../components/screens/menstrual-culture/Testimonies'
import VallsEncume from '../components/screens/encume/vallsEncume/VallsEncume'
import NewsletterCTA from '../components/NewsletterCTA'

const MenstrualCulturePage = () => {
    return (
        <>
            <MenstrualCultureDefinition />
            <MenstrualCultureHero />
            <MenstrualCultureEncumePoster />
            <Testimonies />
            <VallsEncume />
            <MenstrualCultureGallery />
            <NewsletterCTA />
        </>
    )
}

export default MenstrualCulturePage
